import JsPDF, { jsPDFOptions } from 'jspdf';
import autoTable, { Styles, UserOptions } from 'jspdf-autotable';
import { callAddFont as callBoldFont } from 'src/fonts/Vazir/static/Vazirmatn-Bold-normal';
import { callAddFont as callRegularFont } from 'src/fonts/Vazir/static/Vazirmatn-Regular-normal';

export interface PdfExportInterface {
  headers: string[];
  tableBodyValues: (string | number | any)[][];
  interestName?: string;
  options?: jsPDFOptions;
  docStyle?: UserOptions;
  isReturnFunc?: boolean;
  headStyles?: Partial<Styles>;
}

// Customizable pdf export function
export function pdfExport({
  headers,
  tableBodyValues,
  interestName,
  options,
  docStyle,
  isReturnFunc,
  headStyles,
}: PdfExportInterface) {
  JsPDF.API.events.push(['addFonts', callRegularFont]);

  JsPDF.API.events.push(['addFonts', callBoldFont]);

  // Create doc instance that takes it options from options parameter
  const doc = new JsPDF({ orientation: 'landscape', ...(options ? { ...options } : undefined) });

  doc.setFont('Vazirmatn-Regular');

  const columnStyles: any = {};
  tableBodyValues[0].forEach((value, idx) => {
    columnStyles[idx] = { cellWidth: value.cellWidth };
  });

  // Apply custom style which is given as docStyle parameter
  autoTable(doc, {
    head: [headers],
    body: tableBodyValues.map((arr) => arr.map((obj) => obj.field)),
    styles: {
      font: 'Vazirmatn-Regular',
      overflow: 'linebreak',
      cellWidth: 'wrap',
      fontSize: 8,
    },
    columnStyles,
    headStyles: {
      font: 'Vazirmatn-Bold',
      fontStyle: 'bold',
      fillColor: '#347768',
      fontSize: 10,
      ...headStyles,
    },
    ...docStyle,
  });

  // // Save pdf as given name
  // doc.save(`${interestName}.pdf`);
  // if (isReturnFunc) {
  //   return doc.output('blob');
  // }
  return doc.output('blob');
}
